import { useContext, ref } from '@nuxtjs/composition-api'
import { useLoading } from './ui/useLoading'
import { Store } from '~/types/store'
import { SocialLink } from '~/types/common'

export const useStoreDetail = () => {
  const { app } = useContext()
  const loading = useLoading()
  const socialLinksLoading = useLoading()

  const store = ref<Store | null>(null)
  const socialLinks = ref<SocialLink[]>([])

  const getStore = (url: string) => {
    return loading.scope(async () => {
      store.value = await app.$api.store.getByUrl(url)
    })
  }
  const getStoreByName = (name: string) => {
    return loading.scope(async () => {
      store.value = await app.$api.store.getByName(name)
    })
  }
  const getSocialLinks = async (storeId: number) => {
    await socialLinksLoading.scope(async () => {
      socialLinks.value = await app.$api.store.getSocialLinks(storeId)
    })
  }

  return {
    loading: loading.value,
    socialLinksLoading: socialLinksLoading.value,
    store,
    socialLinks,

    getStore,
    getStoreByName,
    getSocialLinks,
  }
}
